import { render, staticRenderFns } from "./BannerCamara.vue?vue&type=template&id=38f3b320&scoped=true"
import script from "./BannerCamara.vue?vue&type=script&lang=js"
export * from "./BannerCamara.vue?vue&type=script&lang=js"
import style0 from "./BannerCamara.vue?vue&type=style&index=0&id=38f3b320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f3b320",
  null
  
)

export default component.exports